import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from '@cloudfactorydk/ng2-tooltip-directive';
import { IonicModule } from '@ionic/angular';
import { VariantChipsComponent } from './variant-chips.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    TooltipModule
  ],
  exports: [VariantChipsComponent],
  declarations: [VariantChipsComponent]
})
export class VariantChipsModule { }
